import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "confirmEmail",
    path: `${AUTH_PREFIX_PATH}/confirm-email`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/confirmEmail")
    ),
  },
  {
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
  {
    key: "resetPassword",
    path: `${AUTH_PREFIX_PATH}/reset-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/new-password")
    ),
  },
];
const allRoles = [
  "Admin",
  "HR Manager",
  "HR Assessment",
  "Technical Assessment",
  "Recruiter",
  "Candidate",
  "Agency",
];
export const protectedRoutes = [
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboard`,
    roles: allRoles,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "editProfile",
    path: `${APP_PREFIX_PATH}/Account/EditProfile`,
    roles: allRoles.filter((e) => e !== "Candidate" && e !== "Agency"),
    component: React.lazy(() => import("views/app-views/Account/EditProfile")),
  },

  {
    key: "addStaff",
    path: `${APP_PREFIX_PATH}/Staff/addStaff`,
    roles: allRoles.filter((e) => e === "Admin"),
    component: React.lazy(() => import("views/app-views/Users/Staff/AddStaff")),
  },
  {
    key: "editStaff",
    path: `${APP_PREFIX_PATH}/Staff/editStaff/:id`,
    roles: allRoles.filter((e) => e === "Admin"),
    component: React.lazy(() =>
      import("views/app-views/Users/Staff/EditStaff")
    ),
  },
  {
    key: "staffList",
    path: `${APP_PREFIX_PATH}/Staff/StaffList`,
    roles: allRoles.filter((e) => e === "Admin" || e === "HR Manager"),
    component: React.lazy(() =>
      import("views/app-views/Users/Staff/StaffList")
    ),
  },
  {
    key: "emailConfiguration",
    path: `${APP_PREFIX_PATH}/EmailConfiguration`,
    roles: allRoles.filter((e) => e === "Admin"),
    component: React.lazy(() => import("views/app-views/Configuration")),
  },
  {
    key: "candidatesList",
    path: `${APP_PREFIX_PATH}/Candidate/CandidatesList`,
    roles: allRoles.filter(
      (e) =>
        e !== "Admin" &&
        e !== "Candidate" &&
        e !== "HR Assessment" &&
        e !== "Technical Assessment"
    ),
    component: React.lazy(() =>
      import("views/app-views/Users/Candidates/CandidatesList")
    ),
  },
  {
    key: "agenciesList",
    path: `${APP_PREFIX_PATH}/Agency/AgenciesList`,
    roles: allRoles.filter((e) => e === "Recruiter" || e === "HR Manager"),
    component: React.lazy(() =>
      import("views/app-views/Users/Agencies/AgenciesList")
    ),
  },
  {
    key: "pendingAgenices",
    path: `${APP_PREFIX_PATH}/PendingAgenices`,
    roles: allRoles.filter((e) => e === "HR Manager"),
    component: React.lazy(() => import("views/app-views/PendingAgencies")),
  },
  {
    key: "addAgency",
    path: `${APP_PREFIX_PATH}/Agencies/AddAgency`,
    roles: allRoles.filter((e) => e === "Recruiter" || e === "HR Manager"),
    component: React.lazy(() =>
      import("views/app-views/Users/Agencies/AddAgency")
    ),
  },
  {
    key: "editAgency",
    path: `${APP_PREFIX_PATH}/Agencies/EditAgency/:id`,
    roles: allRoles.filter(
      (e) => e === "Recruiter" || e === "HR Manager" || e === "Agency"
    ),
    component: React.lazy(() =>
      import("views/app-views/Users/Agencies/EditAgency")
    ),
  },

  {
    key: "vacancies",
    path: `${APP_PREFIX_PATH}/Vacancies/VacanciesList`,
    roles: allRoles.filter((e) => e !== "Admin"),
    component: React.lazy(() =>
      import("views/app-views/Vacancies/VacanciesList")
    ),
  },
  {
    key: "addVacancy",
    path: `${APP_PREFIX_PATH}/Vacancies/AddVacancy`,
    roles: allRoles.filter((e) => e === "HR Manager" || e === "Recruiter"),
    component: React.lazy(() => import("views/app-views/Vacancies/AddVacancy")),
  },
  {
    key: "editVacancy",
    path: `${APP_PREFIX_PATH}/Vacancies/EditVacancy/:id`,
    // roles: allRoles.filter((e) => e === "HR Manager"),
    component: React.lazy(() =>
      import("views/app-views/Vacancies/EditVacancy")
    ),
  },
  {
    key: "offers",
    path: `${APP_PREFIX_PATH}/Offers/OffersList`,
    roles: allRoles.filter((e) => e !== "Admin"),
    component: React.lazy(() => import("views/app-views/Offers/OffersList")),
  },
  {
    key: "addOffer",
    path: `${APP_PREFIX_PATH}/offers/AddOffer/:applicantId`,
    roles: allRoles.filter((e) => e === "Recruiter" || e === "HR Manager"),
    component: React.lazy(() => import("views/app-views/Offers/AddOffer")),
  },
  {
    key: "editOffer",
    path: `${APP_PREFIX_PATH}/Offers/EditOffer/:id`,
    roles: allRoles.filter((e) => e !== "Agency" || e !== "Candidate"),
    component: React.lazy(() => import("views/app-views/Offers/EditOffer")),
  },

  // {
  //   key: "candidateDetails",
  //   path: `${APP_PREFIX_PATH}/Candidate/Details/:Id`,
  //   component: React.lazy(() =>
  //     import("views/app-views/Users/Candidates/CandidateDetails")
  //   ),
  // },
  {
    key: "candidateDetails",
    path: `${APP_PREFIX_PATH}/Candidate/Details/:id`,
    roles: allRoles.filter((e) => e !== "Admin"),
    component: React.lazy(() =>
      import(
        "views/app-views/Users/Candidates/CandidateDetails/ViewDetailsCandidate"
      )
    ),
  },

  {
    key: "addCandidate",
    path: `${APP_PREFIX_PATH}/Candidate/AddCandidate/:agencyId`,
    roles: allRoles.filter((e) => e === "Agency"),
    component: React.lazy(() =>
      import("views/app-views/Users/Candidates/CandidateDetails/AddCandidate")
    ),
  },
  {
    key: "interview",
    path: `${APP_PREFIX_PATH}/Interview/InterviewLsit`,
    roles: allRoles.filter((e) => e !== "Admin" && e !== "Candidate"),
    component: React.lazy(() =>
      import("views/app-views/Interviews/InterviewList")
    ),
  },
  {
    key: "addInterview",
    path: `${APP_PREFIX_PATH}/Interview/AddInterview`,
    roles: allRoles.filter((e) => e === "Recruiter" || e === "HR Manager"),

    component: React.lazy(() =>
      import("views/app-views/Interviews/AddInterview")
    ),
  },
  {
    key: "editInterview",
    path: `${APP_PREFIX_PATH}/Interviews/EditInterview/:id`,
    roles: allRoles.filter(
      (e) =>
        e === "HR Assessment" ||
        e === "Recruiter" ||
        e === "HR Manager" ||
        e === "Technical Assessment"
    ),
    component: React.lazy(() =>
      import("views/app-views/Interviews/EditInterview")
    ),
  },
  {
    key: "applicationList",
    path: `${APP_PREFIX_PATH}/Application/List`,
    roles: allRoles.filter((e) => e !== "Admin"),
    component: React.lazy(() =>
      import("views/app-views/Application/ApplicationList")
    ),
  },
  {
    key: "viewDeTails",
    path: `${APP_PREFIX_PATH}/Application/ViewDetails/:id`,
    roles: allRoles.filter((e) => e !== "Admin"),
    component: React.lazy(() =>
      import("views/app-views/Application/ViewDetails")
    ),
  },
  {
    key: "pendingOffers",
    path: `${APP_PREFIX_PATH}/PendingOffers`,
    roles: allRoles.filter((e) => e === "HR Manager"),
    component: React.lazy(() => import("views/app-views/PendingOffers")),
  },
  // {
  //   key: "history",
  //   path: `${APP_PREFIX_PATH}/Candidate/History/:id`,
  //   roles: allRoles.filter((e) => e !== "Admin" && e !== "Candidate"),
  //   component: React.lazy(() => import("views/app-views/History")),
  // },
  {
    key: "applicationHistory",
    path: `${APP_PREFIX_PATH}/Application/History/:id`,
    roles: allRoles.filter((e) => e === "HR Manager" && e === "Recruiter"),
    component: React.lazy(() =>
      import("views/app-views/Application/ApplicationHistory")
    ),
  },
  {
    key: "reportApplication",
    path: `${APP_PREFIX_PATH}/Report/Applications/:id`,
    roles: allRoles.filter((e) => e === "HR Manager" || e === "Recruiter"),
    component: React.lazy(() =>
      import("views/app-views/Users/Candidates/Report/ApplicationReport")
    ),
  },
  {
    key: "applicationDetails",
    path: `${APP_PREFIX_PATH}/Report/Application/Details/:id`,
    roles: allRoles.filter((e) => e === "HR Manager" || e === "Recruiter"),
    component: React.lazy(() =>
      import("views/app-views/Users/Candidates/Report/Details")
    ),
  },
  {
    key: "vacanciesTitleList",
    path: `${APP_PREFIX_PATH}/VacancyTitle/VacancyTitleList`,
    roles: allRoles.filter((e) => e === "HR Manager"),
    component: React.lazy(() =>
      import("views/app-views/VacanciesTitle/VacanciesTitleList")
    ),
  },
  {
    key: "addVacancyTitle",
    path: `${APP_PREFIX_PATH}/VacancyTitle/AddVacancyTitle`,
    roles: allRoles.filter((e) => e === "HR Manager"),

    component: React.lazy(() =>
      import("views/app-views/VacanciesTitle/AddVacancyTitle")
    ),
  },
  {
    key: "EditVacancyTitle",
    path: `${APP_PREFIX_PATH}/VacanciesTitle/EditVacancyTitle/:id`,
    roles: allRoles.filter((e) => e === "HR Manager"),
    component: React.lazy(() =>
      import("views/app-views/VacanciesTitle/EditVacancyTitle")
    ),
  },
  {
    key: "candidateReportTab",
    path: `${APP_PREFIX_PATH}/Report/CandidateReport/:id`,
    roles: allRoles.filter((e) => e === "HR Manager" || e === "Recruiter"),
    component: React.lazy(() =>
      import("views/app-views/Report/CandidateReport")
    ),
  },
  {
    key: "agencyReportTab",
    path: `${APP_PREFIX_PATH}/Report/AgencyReport`,
    roles: allRoles.filter((e) => e === "HR Manager" || e === "Recruiter"),
    component: React.lazy(() => import("views/app-views/Report/AgencyReport")),
  },
  {
    key: "vacancyReportTab",
    path: `${APP_PREFIX_PATH}/Report/VacancyReport`,
    roles: allRoles.filter((e) => e === "HR Manager" || e === "Recruiter"),
    component: React.lazy(() => import("views/app-views/Report/VacancyReport")),
  },
];
